
// src/Apps/App1.jsx
export default function Secuenciador() {
  return (
    <iframe
      src={process.env.REACT_APP_APP1_URL}  //"/SecuenciadorGOL/"
      title="Secuenciador del Juego de la Vida"
      style={{ width: "100%", height: "100vh", border: "none" }}
      allow="clipboard-write"
    />
  );
}
